import style from './orders-sidebar-section-header-chip.module.less';

/**
 * @param {object} props
 * @param {ReactNode} props.children
 * @returns {JSX.Element}
 */
export const OrdersSidebarSectionHeaderChip = ({ children }) => {
  return <span className={style['orders-sidebar-section-header-chip']}>{children}</span>;
};
